import { render, staticRenderFns } from "./SosCurrentPlanBadge.vue?vue&type=template&id=62ee04a0&lang=pug"
import script from "./SosCurrentPlanBadge.vue?vue&type=script&lang=js"
export * from "./SosCurrentPlanBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports